<app-list-view [pConn$]="pConn$"></app-list-view>

